module.exports = __webpack_public_path__ + "img/登录验证1.e539ab12.jpg";